import { FALLBACK, PARAMS } from "router/constants/Params";
import i18next from "i18next";

export function getLangWithFallback(): string {
  return i18next.resolvedLanguage ?? FALLBACK[PARAMS.LANGUAGE];
}
